import { render, staticRenderFns } from "./singleSelection.vue?vue&type=template&id=47c6e6db&scoped=true&lang=html&"
import script from "./singleSelection.vue?vue&type=script&lang=js&"
export * from "./singleSelection.vue?vue&type=script&lang=js&"
import style0 from "./singleSelection.vue?vue&type=style&index=0&id=47c6e6db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6e6db",
  null
  
)

export default component.exports